import { cn } from "@/lib/utils";

import { NavLinks } from "./NavLinks";
import { MobileMenuProps } from "./types";

export const MobileMenu = ({
  mobileMenuOpen,
  toggleMobileMenu,
  navItems,
  isActive,
  handleLogout,
  collapsed,
}: MobileMenuProps) => (
  <div
    className={cn(
      "md:hidden fixed top-0 left-0 right-0 bottom-0 z-40 bg-background transition-opacity",
      mobileMenuOpen
        ? "animate-in fade-in opacity-100"
        : "animate-out fade-out opacity-0 pointer-events-none"
    )}
  >
    <div
      className={cn(
        "fixed left-0 right-0 bottom-0 top-16 bg-background text-foreground p-5 transition-transform overflow-y-auto",
        mobileMenuOpen
          ? "animate-in slide-in-from-top"
          : "animate-out slide-out-to-top"
      )}
    >
      <div className="flex flex-col h-full">
        <NavLinks
          navItems={navItems}
          isActive={isActive}
          collapsed={collapsed}
          mobile={true}
          onMobileMenuClose={toggleMobileMenu}
          handleLogout={handleLogout}
        />
      </div>
    </div>
  </div>
);
